import React from "react";
import { money } from "./feeUtils";

export const FeeSummaryCards = ({ summary }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
    {[
      { k: "total", label: "Total fees", val: summary.total, accent: "text-zinc-900" },
      { k: "paid", label: "Paid", val: summary.paid, accent: "text-emerald-600" },
      { k: "outstanding", label: "Outstanding", val: summary.outstanding, accent: "text-amber-600" },
    ].map((c) => (
      <div key={c.k} className="border border-zinc-200 bg-white p-4" data-testid={`fees-summary-${c.k}`}>
        <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-500">{c.label}</p>
        <p className={`font-heading text-2xl font-black tracking-tight mt-1 ${c.accent}`}>{money.format(c.val || 0)}</p>
      </div>
    ))}
  </div>
);
